import {
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button
} from '@mui/material'
import React, { useCallback } from 'react'
import { UserState } from '../state/user'
import { useFormik } from 'formik'
import { RefreshActions } from '../state/refresh'
import { useDispatch, useSelector } from 'react-redux'
import { useRequests } from '../requests/useRequests'
import { State } from '../types/state'
import { useIsMobileView } from '../hooks/useIsMobileView'

const CompanyDetails = (): JSX.Element => {
  const dispatch = useDispatch()
  const isMobileView = useIsMobileView()
  const requestMaker = useRequests()
  const userState = useSelector((state: State) => state.user)

  const validate = (user: Partial<UserState>): Partial<UserState> => {
    const errors: typeof user = {}

    return errors
  }

  const onSubmit = useCallback(
    async (user: UserState): Promise<void> => {
      await requestMaker.updateUserCompanyDetails({
        name: user.name!,
        taxId: user.taxId!,
        street: user.street!,
        city: user.city!,
        zipCode: user.zipCode!,
        accountNumber: user.accountNumber!
      })
      dispatch(
        RefreshActions.setToastMessage({
          message: 'Succesfully updated company details'
        })
      )
      dispatch(RefreshActions.refreshUserState())
    },
    [requestMaker, dispatch]
  )

  const formik = useFormik({
    initialValues: userState,
    onSubmit,
    enableReinitialize: true,
    validate
  })

  return (
    // <Box
    //   sx={{
    //     border: '1px solid #3f51b5',
    //     borderRadius: '15px',
    //     width: isMobileView ? '90vw' : '50vw',
    //     margin: 'auto',
    //     marginTop: '1vh'
    //   }}
    // >
    // <ProfileContainer component={Paper}>
    // <div style={backgroundStyle} />
    <form>
      <div style={{ width: isMobileView ? '80vw' : '40vw', margin: 'auto' }}>
        <DialogTitle>Company details</DialogTitle>
        <DialogContent>
          <TextField
            margin='dense'
            id='name'
            label='Name'
            type='name'
            fullWidth
            variant='standard'
            value={formik.values.name}
            onChange={formik.handleChange}
          />
          <TextField
            margin='dense'
            id='taxId'
            label='Tax id'
            type='name'
            fullWidth
            variant='standard'
            value={formik.values.taxId}
            onChange={formik.handleChange}
          />
          <TextField
            margin='dense'
            id='street'
            label='Street'
            type='name'
            fullWidth
            variant='standard'
            value={formik.values.street}
            onChange={formik.handleChange}
          />
          <TextField
            margin='dense'
            id='city'
            label='City'
            type='name'
            fullWidth
            variant='standard'
            value={formik.values.city}
            onChange={formik.handleChange}
          />
          <TextField
            margin='dense'
            id='zipCode'
            label='Zip code'
            type='name'
            fullWidth
            variant='standard'
            value={formik.values.zipCode}
            onChange={formik.handleChange}
          />
          <TextField
            margin='dense'
            id='accountNumber'
            label='Account number'
            type='name'
            fullWidth
            variant='standard'
            value={formik.values.accountNumber}
            onChange={formik.handleChange}
          />
        </DialogContent>
      </div>

      <DialogActions>
        <Button
          onClick={formik.handleSubmit as any}
          style={{ margin: 'auto' }}
          variant='contained'
        >
          Update
        </Button>
      </DialogActions>
    </form>
    // </ProfileContainer>
  )
}

export default CompanyDetails
